module.exports = __webpack_public_path__ + "media/images/front/icons/lock-29e46628bda8fa1886f96cc61239720a.svg";